const GSBasedOnProduct = {
  NSTSPS: {
    pageId: 'NS_IAD_TICKET_DETAILS',
    challengerDetailsWidgetGroupId: 'NS_IAD_CHALLENGER_DETAILS',
    ticketBasicDetailsWidgetGroupId: 'NS_IAD_TICKET_BASIC_DETAILS',
    ticketBasicDetailsWidgetId: 'NS_IAD_TICKET_BASIC_DETAILS',
    challengerExecutionDetailsWidgetId: 'NS_IAD_CHALLENGER_EXECUTION_DETAILS',
    challengerRunInstanceWidgetId: 'NS_IAD_CHALLENGER_RUN_INSTANCE',
    challengerWatchListId: 'NS_IAD_CHALLENGER_WATCHLISTS',
    challengerWhiteListId: 'NS_IAD_CHALLENGER_WHITELISTS'
  },
  RS: {
    pageId: 'RS_TICKET_DETAILS',
    challengerDetailsWidgetGroupId: 'RS_CHALLENGER_DETAILS',
    ticketBasicDetailsWidgetGroupId: 'RS_TICKET_BASIC_DETAILS',
    ticketBasicDetailsWidgetId: 'RS_TICKET_BASIC_DETAILS',
    challengerExecutionDetailsWidgetId: 'RS_CHALLENGER_EXECUTION_DETAILS',
    challengerRunInstanceWidgetId: 'RS_CHALLENGER_RUN_INSTANCE',
    challengerWatchListId: 'RS_CHALLENGER_WATCHLISTS',
    challengerWhiteListId: 'RS_CHALLENGER_WHITELISTS'
  }
};

const GSKeyByProductSourceId = (sourceId) => {
  let gsSelectionModuleName = 'NSTSPS';
  if (sourceId == '7' || sourceId == '9' || sourceId == '16') {
    gsSelectionModuleName = 'NSTSPS';
  } else if (sourceId == '17') {
    gsSelectionModuleName = 'RS';
  }
  return gsSelectionModuleName;
};

export { GSBasedOnProduct, GSKeyByProductSourceId };
